import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledPayoutDetailsContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('SMALL')};
    padding-bottom: ${theme.spacing('LARGE')};
    padding-top: ${theme.spacing('LARGE')};
    border-bottom: 1px solid ${theme.palette.gray.light_gray};

    &:first-of-type {
      padding-top: 0;
    }

    &:last-of-type {
      padding-bottom: 0;
      border-bottom: none;
    }
  `
);

export const StyledHelpCenterTipContainer = styled('div')(
  ({ theme }) => css`
    background-color: ${theme.palette.background.info};
    column-gap: ${theme.spacing('SMALL')};
    display: flex;
    padding: ${theme.spacing('LARGE')};
  `
);
